import styled from 'styled-components';
import {
  WhiteFour,
  WhiteTwo,
  BrownishGrey,
  Black,
  SunYellow,
  NiceBlue,
  Red,
  Bluish,
  WhiteThree
} from '../../styles/Colours';

export const Input = styled.input`
  display: inline-block;
  margin-top: 30px;
  width: 100%;
  border: none;
  background: ${WhiteFour};
  box-shadow: none;
  outline: none;
  outline-color: transparent;
  outline-width: 0;
  color: ${Black};

  &:disabled {
    background: ${WhiteThree};
  }

  &:hover,
  &:active,
  &:focus {
    box-shadow: none;
    border: none;
    outline: none;
    outline-color: transparent;
    outline-width: 0;
  }
`;

export const InputBox = styled.div`
  display: inline-block;
  width: 100%;
  background: ${props => (props.disabled ? WhiteThree : WhiteFour)};
  border: 1px solid ${WhiteTwo};
  padding: 0 20px 10px 20px;
  position: relative;
`;

export const Label = styled.div`
  position: absolute;
  top: ${props => (props.active ? '10px' : '23px')};
  left: 20px;
  font-size: ${props => (props.active ? '13px' : '14px')};
  font-weight: 500;
  color: ${props => (props.error ? Red : BrownishGrey)};
  transition: all 0.2s ease;
  pointer-events: none;
`;

export const ActiveBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${props => (props.active || props.error ? '4px' : '0')};
  background: ${props => (props.error ? Red : SunYellow)};
  transition: all 0.2s linear;
`;

export const CheckboxComponent = styled.div`
  display: inline-block;
  width: 100%;
  margin-top: 10px;

  .ant-checkbox-wrapper,
  ant-checkbox {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    color: ${({ error, secondary }) => {
      if (error) return Red;
      if (secondary) return WhiteFour;
      return BrownishGrey;
    }};

    a {
      text-decoration: underline;
      color: ${({ error, secondary }) => {
        if (error) return Red;
        if (secondary) return WhiteFour;
        return BrownishGrey;
      }};
    }
  }

  .ant-checkbox-inner {
    width: 25px;
    height: 25px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${NiceBlue};
    border-color: ${NiceBlue};
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${NiceBlue};
  }
  .ant-checkbox-inner:after {
    transform: rotate(45deg) scale(0);
    left: 9px;
    top: 5px;
  }
  .ant-checkbox-checked .ant-checkbox-inner:after {
    transform: rotate(45deg) scale(1.6);
  }
`;

export const AreaText = styled.textarea`
  display: inline-block;
  margin-top: 30px;
  width: 100%;
  border: none;
  background: ${WhiteFour};
  box-shadow: none;
  outline: none;
  outline-color: transparent;
  outline-width: 0;
  color: ${Black};

  &:hover,
  &:active,
  &:focus {
    box-shadow: none;
    border: none;
    outline: none;
    outline-color: transparent;
    outline-width: 0;
  }
`;

export const RadioComponent = styled.div`
  margin-top: 10px;
  .ant-radio-group {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    color: ${BrownishGrey};
  }

  .ant-radio-group-large {
    span {
      float: left;
    }

    span.ant-radio + * {
      margin-top: 5px;
    }

    .ant-radio-wrapper {
      margin-right: 40px;
    }
    .ant-radio-inner {
      width: 30px;
      height: 30px;
      font-family: Montserrat;
    }
    .ant-radio-inner:after {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: ${NiceBlue};
    }

    i {
      font-size: 30px;
      margin-left: 10px;
      color: ${Bluish};
    }

    .ant-radio-checked:after {
      border: 1px solid ${NiceBlue};
    }
    .ant-radio-checked .ant-radio-inner {
      border-color: ${NiceBlue};
    }

    .ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
    .ant-radio:hover .ant-radio-inner,
    .ant-radio-focused .ant-radio-inner {
      border-color: ${NiceBlue};
    }
  }
`;

export const NumberBox = styled.div`
  display: inline-block;
  background: ${props => (props.disabled ? WhiteThree : WhiteFour)};
  border: 1px solid ${WhiteTwo};
  padding: 10px 5px 10px 15px;
  position: relative;

  ${Input} {
    margin-top: 0;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Inputs/InputStyles.js